import { fadeIn, fadeOut } from 'dascat-utils';

function ready() {

  const copyToClipboardInput = document.getElementById('copy-text-input');
  const copyToClipboardButton = document.getElementById('copy-text-icon');
  const copyToClipboardButtonWrapper = document.getElementById('copy-text-wrapper');

  if (copyToClipboardButton != null) {
    copyToClipboardButton.addEventListener('click', () => {

      let textValue = null;

      if (copyToClipboardInput != null) {
        textValue = copyToClipboardInput.value;
      }

      if (textValue != null) {
        // console.log(textValue);
        window.navigator.clipboard.writeText(textValue);

        const successElement = copyToClipboardButtonWrapper.appendChild(document.createElement('div'));
        successElement.classList.add('absolute', '-top-[5px]', 'left-1/2', '-translate-x-1/2', '-translate-y-full', 'bg-black', 'rounded-md', 'p-2');

        const successElementText = successElement.appendChild(document.createElement('div'));
        successElementText.classList.add('text-white', 'text-sm', 'w-max');
        successElementText.innerHTML= 'Link copiado!';

        fadeIn(successElement, 200);

        setTimeout(() => {
          fadeOut(successElement, 500);
        }, 1000)
      }
    })
  }

};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ready);
} else {
  ready();
}
